@if (loadingProducts()) {
  <div class="flex items-center justify-center">
    <div class="pointer-events-none h-12 w-48 animate-pulse overflow-hidden rounded-md bg-stone-50"></div>
  </div>
} @else if (intervalOptions().length > 1) {
  <div class="flex justify-center">
    <p-selectbutton [ngModel]="selectedInterval()" (onChange)="onIntervalChange($event)" [options]="intervalOptions()" size="large" />
  </div>
}

<div class="mt-4 flex gap-4 max-md:flex-col max-md:items-center">
  @for (item of subscriptionProducts(); track $index) {
    <app-product-box [loading]="loadingProducts()" [product]="item" [selectedInterval]="selectedInterval()" class="max-md:w-full" />
  }
</div>
